import {createStore} from "redux";
import combinedReducer from "../Reducers";

const store = createStore(combinedReducer);
export default store;
